import { ChartDonut, STATUSPAGE } from '@repo/ui';

interface ChartUsersOnlinePerPlatformProps {
  saveUsersOnlinePerPlatform: {
    web: number;
    appProfessional: number;
    appStudent: number;
  };
  loading: STATUSPAGE;
  legendItems: {
    label: string;
    colorClass: string;
    icon: string;
  }[];
  colorsCartDonut: string[];
  titleChartDonut: string;
  labelsCartDonut: string[];
}

export const ChartUsersOnlinePerPlatform = ({
  loading,
  legendItems,
  labelsCartDonut,
  colorsCartDonut,
  titleChartDonut,
  saveUsersOnlinePerPlatform,
}: ChartUsersOnlinePerPlatformProps) => {
  return (
    <ChartDonut
      loading={loading}
      chartData={[
        saveUsersOnlinePerPlatform?.web,
        saveUsersOnlinePerPlatform?.appProfessional,
        saveUsersOnlinePerPlatform?.appStudent,
      ]}
      legendItems={legendItems || []}
      colors={colorsCartDonut || []}
      title={titleChartDonut}
      labels={labelsCartDonut || []}
    />
  );
};
